module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8WUfR"))).then(() => parcelRequire('1iHdE'));